var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SpecialLayout',{on:{"ok":_vm.ok}},[_c('span',[_vm._v("Ein Backup wird gerade aufgespielt.")]),_c('span',[_vm._v("Bitte warten Sie einen Moment.")])])}
var staticRenderFns = []

export { render, staticRenderFns }